import React, { useState, useEffect } from 'react';
import axios from 'axios';

import Spinner from './Spinner';
import { getLocale, LocaleProvider } from './locales';
import { useBrandedDocTitle } from './utils';
import { BrandingDataProvider, Branding } from './dataProviders';
import useLayout from './useLayout';


export default function Returns() {
  const locale = getLocale();
  const [branding,setBranding] = useState<Branding>();

  useEffect( () => {
    if( !branding ) {
      axios.get('/mocks/branding/branding1.json').then(
        response => setBranding(response.data),
        error => { throw new Error(error); }
      );
    }
  }, [branding] );

  const Layout = useLayout(branding);

  useBrandedDocTitle(branding);

  if( !branding ) {
    return <Spinner />;
  }

  return <LocaleProvider locale={locale}>
    <BrandingDataProvider value={branding}>
      <Layout.Layout>
        <Layout.ReturnsPage />
      </Layout.Layout>
    </BrandingDataProvider>
  </LocaleProvider>;
}
